(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  const bnonDesktopHeaderMedia = window.matchMedia('(min-width: 750px)');
  const bnonMobileHeaderMedia = window.matchMedia('(max-width: 749px)');

  function bnonSetDetailsState(details, open) {
    if (!details) return;
    const summary = details.querySelector(':scope > summary');

    if (open) {
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      details.querySelectorAll('details[open]').forEach((nested) => {
        nested.removeAttribute('open');
        const nestedSummary = nested.querySelector(':scope > summary');
        if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function bnonInitDesktopHeaderHover(scope = document) {
    scope.querySelectorAll('.bnon-header header-menu').forEach((menu) => {
      if (menu.dataset.bnonHoverReady === 'true') return;
      menu.dataset.bnonHoverReady = 'true';

      const mainDetails = menu.querySelector(':scope > details');
      if (!mainDetails) return;

      menu.addEventListener('mouseenter', () => {
        if (!bnonDesktopHeaderMedia.matches) return;

        document.querySelectorAll('.bnon-header header-menu > details[open]').forEach((details) => {
          if (details !== mainDetails) bnonSetDetailsState(details, false);
        });

        bnonSetDetailsState(mainDetails, true);
      });

      menu.addEventListener('mouseleave', () => {
        if (!bnonDesktopHeaderMedia.matches) return;
        if (menu.contains(document.activeElement)) return;
        bnonSetDetailsState(mainDetails, false);
      });

      menu.querySelectorAll('.bnon-header-submenu-details').forEach((subDetails) => {
        const summary = subDetails.querySelector(':scope > summary');
        if (summary && !summary.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', 'false');

        subDetails.addEventListener('toggle', () => {
          if (!bnonDesktopHeaderMedia.matches || !subDetails.open) return;
          subDetails.parentElement?.parentElement?.querySelectorAll(':scope > li > details[open]').forEach((sibling) => {
            if (sibling !== subDetails) bnonSetDetailsState(sibling, false);
          });
          if (summary) summary.setAttribute('aria-expanded', 'true');
        });
      });
    });
  }

  function bnonReadCartCount() {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) return bubble.textContent.trim();
    return '0';
  }

  function bnonSyncDrawerCartCount(scope = document) {
    const count = bnonReadCartCount();
    scope.querySelectorAll('[data-bnon-drawer-cart-count]').forEach((target) => {
      target.textContent = count;
    });
  }

  function bnonInitMobileDrawer(scope = document) {
    scope.querySelectorAll('[data-bnon-mobile-drawer]').forEach((drawer) => {
      if (drawer.dataset.bnonDrawerReady === 'true') return;
      drawer.dataset.bnonDrawerReady = 'true';

      const details = drawer.querySelector(':scope > details');
      const toggle = details?.querySelector(':scope > summary');
      const overlay = details?.querySelector('[data-bnon-drawer-overlay]');
      const closeButton = details?.querySelector('[data-bnon-drawer-close]');
      if (!details || !toggle) return;

      const setDrawerTop = () => {
        // The drawer covers the entire mobile viewport, including the header bar area.
        drawer.style.setProperty('--bnon-mobile-drawer-top', '0px');
      };

      const closeDrawer = (returnFocus = true) => {
        if (!details.open) return;
        bnonSetDetailsState(details, false);
        document.body.classList.remove('bnon-mobile-menu-open');
        document.querySelector('.section-header')?.classList.remove('menu-open');
        if (returnFocus) toggle.focus({ preventScroll: true });
      };

      toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      details.addEventListener('toggle', () => {
        toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.open) {
          setDrawerTop();
          document.body.classList.add('bnon-mobile-menu-open');
          document.querySelector('.section-header')?.classList.add('menu-open');
          bnonSyncDrawerCartCount(details);
        } else {
          document.body.classList.remove('bnon-mobile-menu-open');
          document.querySelector('.section-header')?.classList.remove('menu-open');
          details.querySelectorAll('[data-bnon-accordion][open]').forEach((nested) => bnonSetDetailsState(nested, false));
        }
      });

      overlay?.addEventListener('click', () => closeDrawer(true));
      closeButton?.addEventListener('click', () => closeDrawer(true));

      details.querySelectorAll('[data-bnon-accordion]').forEach((accordion) => {
        const summary = accordion.querySelector(':scope > summary');
        if (summary && !summary.hasAttribute('aria-expanded')) summary.setAttribute('aria-expanded', 'false');

        accordion.addEventListener('toggle', () => {
          if (summary) summary.setAttribute('aria-expanded', accordion.open ? 'true' : 'false');
          if (!accordion.open) return;

          const list = accordion.parentElement?.parentElement;
          if (!list) return;
          list.querySelectorAll(':scope > li > details[data-bnon-accordion][open]').forEach((sibling) => {
            if (sibling !== accordion) bnonSetDetailsState(sibling, false);
          });
        });
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          closeDrawer(true);
        }
      });

      window.addEventListener('resize', () => {
        if (details.open) setDrawerTop();
        if (!bnonMobileHeaderMedia.matches && details.open) closeDrawer(false);
      });
    });
  }

  function bnonInitHeader(scope = document) {
    bnonInitDesktopHeaderHover(scope);
    bnonInitMobileDrawer(scope);
    bnonSyncDrawerCartCount(scope);
  }

  bnonInitHeader();

  document.addEventListener('shopify:section:load', (event) => bnonInitHeader(event.target));

  const bnonCartBubble = document.querySelector('#cart-icon-bubble');
  if (bnonCartBubble && 'MutationObserver' in window) {
    new MutationObserver(() => bnonSyncDrawerCartCount()).observe(bnonCartBubble, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  } catch(e) { console.error(e); }
})();
})();
